import { MultiSelection } from '../../../shared/checkbox-list/entities/multi-selection.entity';
import { LocalDate } from "../../../shared/jsr310-localdates/types/local-date.type";

export class MessagesCollationnesFilters {
	dateMin: LocalDate | null = null;
	dateMax: LocalDate | null = null;
	agenceId?: number;
	antenneId?: number;
	parcId?: number;
	emetteur: MultiSelection | undefined = new MultiSelection([0,1], true);
	etatParc: MultiSelection | undefined = new MultiSelection([0,1], true);

	constructor() {
	}
}